import { Box, useTheme } from "@mui/material";
import { RectangularLoader } from "../../molecules/skeleton-loader/RectangularLoader";

type DetailsLoaderProps = {
  type?: "timeline" | "trends";
};

export const WorkflowChartLoader = (props: DetailsLoaderProps) => {
  const { type } = props;
  const isTrends = type === "trends";
  return (
    <Box display="flex" width="100%" flexDirection="column" gap="16px">
      <Box display="flex" width="100%" flexGrow={1} flexDirection="row" gap="16px">
        <RectangularLoader width="130px" height={isTrends ? "83px" : "26px"} />
        <RectangularLoader width="130px" height={isTrends ? "83px" : "26px"} />
        <RectangularLoader width="130px" height={isTrends ? "83px" : "26px"} />
        {isTrends && <RectangularLoader width="130px" height={isTrends ? "83px" : "26px"} />}
      </Box>
      <RectangularLoader maxWidth="100%" height="300px" />
    </Box>
  );
};

export const WorkflowChartBox = () => {
  const theme = useTheme();
  return (
    <Box
      display="flex"
      width="100%"
      padding="16px"
      flexDirection="column"
      gap="16px"
      border={`1px solid ${theme.palette.custom.primaryBorder}`}
      borderRadius="6px"
      bgcolor={theme.palette.custom.primaryBackground}
    >
      <Box display="flex" flexDirection="row" width="100%" justifyContent="space-between">
        <Box display="flex" borderRadius="3px" flexDirection="row" justifyContent="flex-start">
          <RectangularLoader width="64px" height={"38px"} />
          <RectangularLoader width="64px" height={"38px"} />
        </Box>
        <RectangularLoader width="442px" height={"38px"} />
      </Box>
      <WorkflowChartLoader type="timeline" />
    </Box>
  );
};
